import { action } from 'typesafe-actions';
import { IPagadorArmazenagem, PagadorArmazenagemTypes } from './types';

export const pagArmazenagemRequest = (inscricaoAtiva: any, cddAtivo: number | undefined) =>
  action(PagadorArmazenagemTypes.LOAD_REQUEST, { inscricaoAtiva, cddAtivo });
export const pagArmazenagemSuccess = (data: IPagadorArmazenagem[]) =>
  action(PagadorArmazenagemTypes.LOAD_SUCCESS, { data });
export const pagArmazenagemFailure = () => action(PagadorArmazenagemTypes.LOAD_FAILURE);

export const cleanPagArmazenagem = () => action(PagadorArmazenagemTypes.CLEAN_PAG_ARMAZENAGEM);
